export const config = {
  fileBaseUrl: import.meta.env.VITE_FILE_BASE_URL
}
